import { ButtonParams, Plugin } from '@jeppesen-foreflight/jmkw-types';
import { PopoutButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { PersonasPopoutComponent } from './buttons/persona/personas-popout/personas-popout.component';

export const PERSONA_TOGGLE_BUTTON: ButtonParams = {
  iconName: 'icon-people_alt',
  automationKey: 'persona-toggle-button',
  tooltipText: 'Persona Options',
  buttonComponent: PopoutButtonComponent,
  contentComponent: PersonasPopoutComponent
};

export const PERSONA_TOGGLE_PLUGIN = new Plugin({
  id: 'personas',
  button: PERSONA_TOGGLE_BUTTON
});
